import axios from "axios";
import { jwtDecode } from 'jwt-decode';
import { SEARCH_ONE_MAP_API } from "./MapConfig";
import { getToken as getRecaptchaToken } from "./recaptcha";

export const Api = "/permits-service/v1/";

export const ApiMap = "/map-service/v1/";
export const ApiMapScreenshotUpload = "/application-service-map-upload/v1/";

export const AerialActivityUrl = "aerial-activity";
export const ShipCrossUrl = "ship";
export const AerialPhotoUrl = "aerial-photo";
export const ApiCraneUrl = "crane";
export const AerialActivityInit = "aerial-activity/init-data";
export const ShipCrossInit = "ship/init-data";
export const AerialPhotoInit = "aerial-photo/init-data";
export const ApiCraneInit = "crane/init-data";
export const AddressApi = "https://www.onemap.gov.sg/api/common/elastic/search";
export const DownloadPdfApi = "/permits-service/v1/document/retrieve";
export const FetchDashboardData = "dashboard/data";
export const FetchDashboardFilter = "dashboard/filter";
export const DashboardDataDelete = "application/remove";
export const DashboardApplicationRetrieve = "application/retrieve";
export const DownloadPdfApiApproved =
  "/permits-service/v1/document/getApprovedDocument";
export const LandingApi = "/permits-service/v1/login";
export const ApiUploadFile = "document/upload";
export const ApiRemoveFile = "document/remove";
export const ApiFileList = "document/list";
export const MapApi = "map/zone-data";
export const EmailVerification = "email/verifyEmail";
export const EmailVerificationWithOTP = "email/verifyEmailWithOTP";
export const SignUpApi = ""
const ONEMAPTOKEN_KEY = 'oMT';

export const Instance = axios.create({
  baseURL: Api,
  withCredentials: false,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
    timeout: 2000,
    pointAccessContent: localStorage.getItem("siteContent"),
  },
});

export const AccountServiceApi = (token, type, baseUrl) => axios.create({
  baseURL: baseUrl ?? "/account-service/v1/",
  withCredentials: false,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
    "Content-Type": type ? "multipart/form-data": "application/json",
    "accept": "*/*",
    timeout: 2000,
    pointAccessContent: token,
  },
});

export const loginServiceApi = (token) => axios.create({
  baseURL: "/login-service/",
  withCredentials: false,
  headers: {
    pointAccessContent: token,
  },
});

export const getAuthToken = (token) => token;

export const axiosInstance = token => {
  return axios.create({
    baseURL: Api,
    withCredentials: false,
    headers: {
      pointAccessContent: getAuthToken(token),
    },
  })
};

export const axiosInstanceMapService = (token) =>
  axios.create({
    baseURL: ApiMap,
    withCredentials: false,
    headers: {
      pointAccessContent: getAuthToken(token),
    },
  });

  export const axiosInstanceMapScreenshotUploadService = (token) =>
  axios.create({
    baseURL: ApiMapScreenshotUpload,
    withCredentials: false,
    headers: {
      pointAccessContent: getAuthToken(token),
    },
  });

 export const mapInItData = async () => {

    try {      
      const recaptchaToken = await getRecaptchaToken();
      
      const url = "/application/map/init";
      const { data: response } = await axiosInstance(recaptchaToken).get(url);
          
     return response;

    } catch (error) {
      console.log("Failed to load mapInItData.", JSON.stringify(error));
    }
    return null;
  };


export const fetchAddress = async (postalCode) => {

  const params = new URLSearchParams({
    searchVal: postalCode,
    returnGeom: "Y",
    getAddrDetails: "Y",
    pageNum: "1"
  });

  try {

    const mapToken = await getMapToken();

    if (!mapToken) {
      throw new Error("OneMap token is missing");
    }

    const response = await axios.get(
      `${AddressApi}/?${params}`,
      { headers: { 'Authorization': `${mapToken}` } }
    );


    if (response?.data?.results && response.data.results.length > 0) {
      return { error: false, data: response.data.results[0] };
    } else {
      console.log("API call successful, but no results found.");
      return { error: true, data: null }
    }
  } catch (error) {
    console.error("API fetch error:", error);

    if (error?.response) {
      const status = error?.response?.status;
      if (status === 401) {
        // Authentication failed
        // Retry with fresh token.

        const initMapData = await mapInItData();
        const response = await axios.get(
          `${AddressApi}/?${params}`,
          { headers: { 'Authorization': `${initMapData?.oneMapToken}` } }
        );

        if (response?.data?.results && response.data.results.length > 0) {
          return { error: false, data: response.data.results[0] };
        }
        else {
          console.log("API call successful, but no results found.");
          return { error: true, data: null }
        }

      } else if (status === 404) {
        //nothing
      }
    }
    return { error: true, data: null }
  }
};


export const mapSearchLocation = async (searchText) => {
    try {

      const oneMapToken = await getMapToken();

      if (!oneMapToken) {
        throw new Error("OneMap token is missing");
      }

      const { data: response } = await axios.get( SEARCH_ONE_MAP_API + searchText,
        {headers: { 'Authorization': `${oneMapToken}`, }}      
      );

      return {error: false, data: response?.results??null };

    } catch (error) {
      console.error("API fetch error:", error);
           
        if (error?.response) {
          const status = error?.response?.status;
          if (status === 401) {
            // Authentication failed
            // Retry with fresh token.

            const initMapData = await mapInItData();

              const { data: response } = await axios.get( SEARCH_ONE_MAP_API + searchText,
                {headers: { 'Authorization': `${initMapData?.oneMapToken}`, }}      
              );

              return {error: false, data: response?.results??null };

          } else if (status === 404) {
            //nothing
          }
        }
        return { error: true, data: null }
      
    }
};


const isTokenExpired = async (token) => {
  if (!token) {
    return true;
  }
  const decoded = await decodeToken(token);
  const currentTime = Date.now() / 1000;
  const bufferInSeconds = 1;
  //const bufferInSeconds = 24*60*60;
  const expWithBuff = decoded.exp - bufferInSeconds;
  // console.log("*****************");
  // console.log("currentTime -->"+currentTime);
  // console.log("expWithBuff -->"+ expWithBuff);
  // console.log("*****************");
  return expWithBuff <= currentTime;
};

const decodeToken = async (token) => {
  try {
    return jwtDecode(token);
  } catch (error) {
    console.error('Failed to decode token', error);
    return null;
  }
};

const getMapToken = async () => {

  let token = localStorage.getItem(ONEMAPTOKEN_KEY);

  const isExpired =  await isTokenExpired(token)

  //console.log("isExpired-->"+isExpired);

  if(!token || isExpired){
    //console.log("1--in");
    const oneMapInit = await mapInItData();
    //console.log("1--oneMapInit  -->"+ JSON.stringify(oneMapInit)); 
    if(oneMapInit?.oneMapToken){
      localStorage.setItem(ONEMAPTOKEN_KEY, oneMapInit?.oneMapToken);
      return oneMapInit?.oneMapToken;
    }
  }

  return localStorage.getItem(ONEMAPTOKEN_KEY);
};


/*
export const loadMapLayerData = async (applicationType, activityType) => {
  console.log("loadMapLayerData applicationType-->"+applicationType);
  console.log("loadMapLayerData activityType-->"+activityType);
   const reqParams = {
      applicationType: applicationType,
      activityType: activityType,
    };
     
    try {
      const recaptchaToken = await ReactRecaptcha3.getToken();

      const response = await axiosInstanceMapService(
        recaptchaToken
      ).post(MapApi, reqParams);

      return response?.data?.mapZones ?? null;
      
    } catch (error) {
      console.error(error);
    }

    return null;

};
*/